export default "__VITE_ASSET__lGjuaWEH__"